import { render, staticRenderFns } from "./MessageGrid.vue?vue&type=template&id=3da5ec82&"
import script from "./MessageGrid.js?vue&type=script&lang=js&"
export * from "./MessageGrid.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports